export default __webpack_public_path__ + "static/media/questionType-img.81cd2d91.png";